import { ofType } from "redux-observable";
import {
  actionTypes,
  addTechnicalUsersCounterActionFailure,
  addTechnicalUsersCounterActionSuccess,
  deleteTechnicalUsersCounterActionFailure,
  deleteTechnicalUsersCounterActionSuccess,
  getAllCountersActionFailure,
  getAllCountersActionSuccess,
  getApplicationCountersActionFailure,
  getApplicationCountersActionSuccess,
  getOuCountersActionFailure,
  getOuCountersActionSuccess,
  getTechnicalUsersRiorgIdentityActionFailure,
  getTechnicalUsersRiorgIdentityActionSuccess,
  getTechnicalUsersRiorgOusActionFailure,
  getTechnicalUsersRiorgOusActionSuccess,
  riorgTechnicalUsersOusActionFailure,
  riorgTechnicalUsersOusActionSuccess,
  updateTechnicalUsersCounterActionFailure,
  updateTechnicalUsersCounterActionSuccess,
} from "./actions";
import { catchError, map, mergeMap, of } from "rxjs";
import {
  adminTechnicalUsersAddCounterService,
  adminTechnicalUsersDeleteCounterService,
  adminTechnicalUsersGetAllCountersService,
  adminTechnicalUsersGetApplicationCountersService,
  adminTechnicalUsersGetOuCountersService,
  adminTechnicalUsersGetRiorgIdentityService,
  adminTechnicalUsersGetRiorgOusService,
  adminTechnicalUsersRiorgOusService,
  adminTechnicalUsersUpdateCounterService,
} from "../../../../service/technicalUserService";

const fetchAllCountersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ALL_COUNTERS),
    mergeMap(() =>
      adminTechnicalUsersGetAllCountersService().pipe(
        map((response: any) => getAllCountersActionSuccess(response)),
        catchError((error: any) => of(getAllCountersActionFailure(error)))
      )
    )
  );

const fetchApplicationCountersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_APP_COUNTERS),
    mergeMap(() =>
      adminTechnicalUsersGetApplicationCountersService().pipe(
        map((response: any) => getApplicationCountersActionSuccess(response)),
        catchError((error: any) =>
          of(getApplicationCountersActionFailure(error))
        )
      )
    )
  );

const fetchOuCountersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_OU_COUNTERS),
    mergeMap(() =>
      adminTechnicalUsersGetOuCountersService().pipe(
        map((response: any) => getOuCountersActionSuccess(response)),
        catchError((error: any) => of(getOuCountersActionFailure(error)))
      )
    )
  );

const addCounterEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADD_TECHNICAL_COUNTER),
    mergeMap((action: any) =>
      adminTechnicalUsersAddCounterService(action.payload).pipe(
        map((response: any) => addTechnicalUsersCounterActionSuccess(response)),
        catchError((error: any) =>
          of(addTechnicalUsersCounterActionFailure(error))
        )
      )
    )
  );

const updateCounterEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_TECHNICAL_COUNTER),
    mergeMap((action: any) =>
      adminTechnicalUsersUpdateCounterService(action.payload).pipe(
        map((response: any) =>
          updateTechnicalUsersCounterActionSuccess(response)
        ),
        catchError((error: any) =>
          of(updateTechnicalUsersCounterActionFailure(error))
        )
      )
    )
  );

const deleteCounterEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_TECHNICAL_COUNTER),
    mergeMap((action: any) =>
      adminTechnicalUsersDeleteCounterService(action.payload).pipe(
        map((response: any) =>
          deleteTechnicalUsersCounterActionSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteTechnicalUsersCounterActionFailure(error))
        )
      )
    )
  );

const getRiorgIdentityEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_RIORG_TECHNICAL_IDENTITY),
    mergeMap((action: any) =>
      adminTechnicalUsersGetRiorgIdentityService().pipe(
        map((response: any) =>
          getTechnicalUsersRiorgIdentityActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getTechnicalUsersRiorgIdentityActionFailure(error))
        )
      )
    )
  );

const getRiorgOusEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_RIORG_OU),
    mergeMap((action: any) =>
      adminTechnicalUsersGetRiorgOusService().pipe(
        map((response: any) =>
          getTechnicalUsersRiorgOusActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getTechnicalUsersRiorgOusActionFailure(error))
        )
      )
    )
  );

const riorgOusEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RIORG_OU),
    mergeMap((action: any) =>
      adminTechnicalUsersRiorgOusService(action.payload).pipe(
        map((response: any) => riorgTechnicalUsersOusActionSuccess(response)),
        catchError((error: any) =>
          of(riorgTechnicalUsersOusActionFailure(error))
        )
      )
    )
  );

export default [
  fetchAllCountersEpic,
  fetchApplicationCountersEpic,
  fetchOuCountersEpic,
  addCounterEpic,
  updateCounterEpic,
  deleteCounterEpic,
  getRiorgIdentityEpic,
  getRiorgOusEpic,
  riorgOusEpic,
];
